interface AnchorGapArgs {
	firstRenderedIndex: number | undefined
	hasRowAtTop: boolean
	complete: boolean
	isSearching: boolean
}

// zero-virtual reserves a slot above a permalink anchor and keeps a high-water
// mark count, so a row leaving the query can strand index 0 with no row and no
// way to get one. Detect it from the outside: index 0 rendered, page settled,
// still empty.
export const shouldResetInboxAnchor = ({
	firstRenderedIndex,
	hasRowAtTop,
	complete,
	isSearching,
}: AnchorGapArgs) =>
	!isSearching && complete && firstRenderedIndex === 0 && !hasRowAtTop
